const DEFAULT_TAG_REDUX_STATE = {
  loadingTags: true,
  tags: [],
};

export default DEFAULT_TAG_REDUX_STATE;
